import { useState } from "react";

import { MoveGroupOfAnimalsToFieldModal } from "components/MyLivestock";

import { Button } from "components";

import { ELEMENTS_IDS } from "constants/ElementsIds";

import styles from "./styles.module.scss";

interface Props {
  buttonLabel?: string;
}

export const MoveGroupOfAnimalsToFieldButton = ({ buttonLabel }: Props) => {
  const [isModalShowing, setIsModalShowing] = useState(false);

  const handleModalToggle = (): void => {
    setIsModalShowing(!isModalShowing);
  };

  return (
    <div className={styles.moveAnimal}>
      <Button
        id={ELEMENTS_IDS.MOVE_GROUP_OF_ANIMALS_TO_FIELD_BUTTON}
        caption={buttonLabel || "Move to location"}
        onClick={handleModalToggle}
      />
      <MoveGroupOfAnimalsToFieldModal showModal={isModalShowing} onToggle={handleModalToggle} />
    </div>
  );
};
